export default class OperatorTagService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntities(params) {
		return this.apiService.callGet('me/OperatorTags', params)
	}

	createEntity(params){
		return this.apiService.callPost('me/OperatorTags', params);
	}

	updateEntity(id, params){
		return this.apiService.callPut('me/OperatorTags/'+id, params);
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('me/OperatorTags/' + id, params)
	}

	searchTagsByName(params){
		return this.apiService.callGet('me/OperatorTags/search', params);
	}
}



// WEBPACK FOOTER //
// ./src/service/OperatorTagService.js